import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { formatPriceToFixed } from "../Utilities/priceUtils";
import BasketItemActions from "./BasketItemActions";
import { bookFormatsFullMap } from "../Utilities/mapUtil";
import useIsDesktop from "../hooks/useIsDesktop";

export default function BasketItemDefaultDetails(props) {
  const languageContext = useContext(LanguageContext);
  const isDesktop = useIsDesktop();
  const formatDropdown = props.dropDowns?.find(
    (dropdown) =>
      dropdown.id === "book-format" ||
      dropdown.id === "calendar-format" ||
      dropdown.id === "tile-size"
  );
  const isCalendar = formatDropdown?.id === "calendar-format";
  const pagesNumber = isCalendar ? null : (props.pagesNumber || props.item?.pages);
  const coverDropdown = props.dropDowns?.find(
    (dropdown) => dropdown.id === "book-cover" || dropdown.id === "tile-frame-color"
  );
  const formatLabelFromDropdown = formatDropdown?.placeholder || null;
  const formatLabel =
    formatLabelFromDropdown ||
    (props.item?.format !== undefined &&
      bookFormatsFullMap.get(props.item.format) &&
      languageContext.getTranslation(bookFormatsFullMap.get(props.item.format)));
  const coverLabel = coverDropdown?.placeholder || null;

  const formattedGrossPrice = formatPriceToFixed(props.grossPrice);
  const formattedNetPrice = formatPriceToFixed(props.netPrice);
  const showFullPrice = props.hasDiscount && formattedGrossPrice;

  return (
    <div className="flex flex-col h-full">
      {props.isMosaic && (
        <div className="pb-8">
          <div>{props.subTitle}</div>
        </div>
      )}

      <div className="flex flex-col gap-3 h-full">
        <div className="flex flex-col gap-2 sm:text-lg text-sm sm:leading-[100%] leading-[90%] text-secondary-foreground">
          {formatLabel && <div>{formatLabel}</div>}
          {coverLabel ? <div>{coverLabel}</div> : null}
          {pagesNumber ? (
            <div>{`${pagesNumber} ${languageContext.getTranslation(
              appConst.PAGES
            )}`}</div>
          ): null}
        </div>

        <div className="text-secondary-foreground flex flex-col gap-3 text-base h-full">
          <div className="flex flex-wrap items-center gap-3">
            {showFullPrice && (
              <span className="line-through text-lg">
                {`${formattedGrossPrice} ₪`}
              </span>
            )}
            {formattedNetPrice && (
              <span className="font-ploni-demibold text-sm sm:text-lg">{`${formattedNetPrice} ₪`}</span>
            )}
          </div>
          {isDesktop && props.upgradeBanner && (
            <div className="hidden md:block mb-4">
              {props.upgradeBanner}
            </div>
          )}
          {isDesktop && (
            <div className="flex flex-col h-full justify-between">
              <div className="h-px w-full bg-disable hidden md:block" />
              <div className="hidden md:flex items-center justify-between mt-4">
                <BasketItemActions {...props} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
